import { Button } from "@material-ui/core";

const ButtonForm = ({ value, handleClick }) => {
  return <div className="button"><Button color="primary" disableElevation variant="contained" onClick={handleClick}> {value}</Button></div>;
};

export default ButtonForm;
